
    <div class="mt-2 alert alert-giallino" *ngIf="loaded && riepilogo?.id">
      <div class="mt-2"><strong>{{ riepilogo.categoria }}</strong></div>
      <strong class="mt-2">Disponibilità {{  riepilogo.tipologia }}</strong>:<br>
      <ul class="mb-0">
        <li *ngFor="let disponibilita of this.riepilogo.disponibilita">{{ disponibilita.giorno }}: {{ disponibilita.orario }}</li>
      </ul>
      <div><strong>Ultimo appuntamento eseguito</strong>: {{ riepilogo.ultimo_appuntamento_eseguito ? (riepilogo.ultimo_appuntamento_eseguito | date: 'dd/MM/yyyy') : '-' }}</div>
      <div><strong>Prossimo appuntamento programmato</strong>: {{ riepilogo.prossimo_appuntamento_programmato ? (riepilogo.prossimo_appuntamento_programmato | date: 'dd/MM/yyyy') : '-' }}</div>
      <div class="mt-2" *ngIf="noteAggiuntive"><strong>Note cliente</strong>: {{ noteAggiuntive }}</div>
    </div>
    <div class="mt-2 alert alert-giallino" *ngIf="loaded && !this.riepilogo">
      Non è ancora stato creato il mantenimento per il cliente selezionato. Per procedere clicca sul pulsante:
      <button (click)="handleCreate()" class="btn btn-primary mt-2">Crea {{ riepilogo.tipologia }}</button>
    </div>
    <div class="mt-2 alert alert-giallino" *ngIf="!loaded">
      Caricamento...
    </div>
  